import { fetchWithTrace } from './fetchWithTrace.js';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const supportService = {
    createTicket: async (formData) => {
        // fetchWithTrace returns { data, correlation } or throws on error
        const { data } = await fetchWithTrace(`${API_BASE}/api/support/ticket`, {
            method: 'POST',
            body: formData,
        });
        return data;
    },

    getTickets: async () => {
        const { data } = await fetchWithTrace(`${API_BASE}/api/support/tickets`);
        return data;
    },

    getTicket: async (ticketId) => {
        const { data } = await fetchWithTrace(`${API_BASE}/api/support/ticket/${ticketId}`);
        return data;
    },

    replyToTicket: async (ticketId, formData) => {
        const { data } = await fetchWithTrace(`${API_BASE}/api/support/ticket/${ticketId}/reply`, {
            method: 'POST',
            body: formData,
        });
        return data;
    }
};
